<!-- <link rel="stylesheet" [href]='sanitizer.bypassSecurityTrustResourceUrl(cssUrl)'> -->

<link rel="stylesheet" href="/assets/theme/info.css" *ngIf="cssTheme=='info'">
<link rel="stylesheet" href="/assets/theme/primary.css" *ngIf="cssTheme=='primary'">
<link rel="stylesheet" href="/assets/theme/secondary.css" *ngIf="cssTheme=='secondary'">
<link rel="stylesheet" href="/assets/theme/danger.css" *ngIf="cssTheme=='danger'">

<!-- <link rel="stylesheet" href='/ediary/assets/theme/info.css' *ngIf="cssTheme=='info'">
<link rel="stylesheet" href='/ediary/assets/theme/primary.css' *ngIf="cssTheme=='primary'">
<link rel="stylesheet" href='/ediary/assets/theme/secondary.css' *ngIf="cssTheme=='secondary'">
<link rel="stylesheet" href='/ediary/assets/theme/danger.css' *ngIf="cssTheme=='danger'"> -->

<router-outlet></router-outlet>
<app-loader></app-loader>
<!-- <app-my-diary></app-my-diary> -->
